import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

export const MultiBrokerVaultManager: React.FC = () => {
  const { language } = useLanguage();
  const [activeBroker, setActiveBroker] = useState<string>('all');

  const brokers = [
    { id: 'all', name: language === 'sk' ? 'Všetky Účty (Slúčené)' : 'Consolidated Portfolio', balance: 546437.86, badge: 'CONSOLIDATED', color: 'bg-slate-900 text-white' },
    { id: 'slsp', name: 'Slovenská Sporiteľňa (ERSTE)', balance: 312450.00, badge: 'SLSP BANK', color: 'bg-blue-900 text-white' },
    { id: 'ibkr', name: 'Interactive Brokers (IBKR)', balance: 168987.86, badge: 'IBKR DIRECT', color: 'bg-amber-800 text-white' },
    { id: 'xtb', name: 'XTB Trading Vault', balance: 65000.00, badge: 'XTB BROKER', color: 'bg-emerald-900 text-white' }
  ];

  return (
    <div className="glass-panel p-6 space-y-4 font-mono">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 pb-3 border-b border-[var(--border-color)]">
        <div>
          <h3 className="text-sm font-extrabold uppercase tracking-widest text-slate-900 flex items-center gap-2">
            <span>🏢</span>
            {language === 'sk' ? 'Správa Viacero Broker Účtov (Multi-Broker Vault)' : 'Multi-Account / Multi-Broker Vault'}
          </h3>
          <p className="text-[10px] text-slate-500 mt-0.5">
            {language === 'sk' ? 'Prepínajte náhľad a konsolidujte majetok naprieč bankami a maklérmi' : 'Switch sub-portfolios or consolidate assets across SLSP, IBKR, and XTB'}
          </p>
        </div>

        <button
          onClick={() => alert(language === 'sk' ? '➕ Nové prepojenie brokera: Vyberte API alebo IMAP mailovú schránku.' : '➕ Connect new broker API or IMAP vault.')}
          className="px-3 py-1.5 rounded-xl text-xs font-bold bg-slate-900 text-white hover:opacity-90 transition-all flex items-center gap-1.5 shadow-sm"
        >
          <span>➕</span>
          <span>{language === 'sk' ? 'Pridať Účet' : 'Add Vault'}</span>
        </button>
      </div>

      {/* Broker Selector Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
        {brokers.map((b) => {
          const isSelected = activeBroker === b.id;
          return (
            <button
              key={b.id}
              onClick={() => setActiveBroker(b.id)}
              className={`p-3.5 rounded-2xl border text-left transition-all flex flex-col justify-between h-24 ${
                isSelected 
                  ? 'bg-slate-900 text-white border-slate-900 shadow-md scale-[1.01]' 
                  : 'bg-white text-slate-800 border-slate-200 hover:border-slate-400'
              }`}
            >
              <div className="flex justify-between items-start w-full">
                <span className="text-[9px] font-black uppercase tracking-wider px-1.5 py-0.5 rounded bg-slate-100 text-slate-700">{b.badge}</span>
                {isSelected && <span className="text-xs text-emerald-400 font-bold">✓ Active</span>}
              </div>

              <div>
                <div className="text-[10px] font-bold truncate opacity-90">{b.name}</div>
                <div className="text-sm font-extrabold mt-0.5">
                  €{b.balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
